import React from 'react'
import { LabelComponent } from './Label.styles'

interface LabelProps {
	children: any
}

export const Label = ({ children }: LabelProps): JSX.Element => {
	return <LabelComponent>{children}</LabelComponent>
}
